import { useAuth } from '../../hooks/auth/useAuth'
import PropTypes from 'prop-types'

export const OptionalAuthRoute = ({ children }) => {
  const { loading } = useAuth()

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">Loading...</div>
      </div>
    )
  }

  return children
}

OptionalAuthRoute.propTypes = {
  children: PropTypes.node.isRequired,
}
